// extracted by mini-css-extract-plugin
module.exports =  {"popover":"Popover-module__popover___PmG6o","withPadding":"Popover-module__withPadding___JtodT"};